<template>
  <span class="animation-num">{{parseIntNum}}</span>
</template>
<script>
export default {
  name: 'animation-num',
  props: {
    num: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showNum: 0,
    };
  },
  computed: {
    parseIntNum() {
      return parseInt(this.showNum, 10);
    },
  },
  watch: {
  },
  created() {
    if (this.num) {
      const singleStepTime = 8;
      const step = 48;
      const endNum = this.num;
      const singleStepNum = endNum / step;
      this.initInterval(singleStepTime, singleStepNum);
    }
  },
  methods: {
    initInterval(singleStepTime, singleStepNum) {
      setTimeout(() => {
        this.showNum += singleStepNum;

        if (this.showNum >= this.num * 0.95) {
          this.showNum = this.num * 0.95;
          this.endNumInterval(singleStepTime + 60, this.num * 0.05 / 3);
          return;
        }
        this.initInterval(singleStepTime + 1, singleStepNum);
      }, singleStepTime);
    },
    endNumInterval(singleStepTime, singleStepNum) {
      setTimeout(() => {
        this.showNum += singleStepNum;
        if (this.showNum >= this.num) {
          this.showNum = this.num;
          this.$emit('animationEnd');
          return;
        }
        this.endNumInterval(singleStepTime + 5, singleStepNum * 0.937);
      }, singleStepTime);
    },

  },
};
</script>
<style lang="less" scoped>
</style>




// WEBPACK FOOTER //
// src/components/common/animation-num.vue